import React, { useState, useEffect } from "react";
// Components
import Navbar from "../../components/Navbar";
import Lojas from "../../assets/navbar/Lojas_on_light_blue.svg";
import { ImPlus } from "react-icons/im";
import ListStore from "../../components/ListStore";
import * as S from "./styles";

import { useHistory, useLocation } from "react-router-dom";

export default function StoreList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={Lojas} />
            <div>
              <S.Title>Lojas</S.Title>
              <S.Description>Cadastro geral de Lojas</S.Description>
            </div>
          </S.BoxUser>

          <S.AddNew onClick={() => history.push("/cadastro-lojas")}>
            <ImPlus
              style={{
                fill: "#00a2e0",
                margin: "0px 0px 0px",
              }}
            />
            <S.Image src={Lojas} />
          </S.AddNew>
        </S.Header>

        <ListStore
          filter={params.get("filter") || ""}
          state={params.get("uf") || ""}
          stateName={params.get("ufName") || ""}
          type={params.get("type") || ""}
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
      </S.Wrapper>
    </>
  );
}
